export enum Stage {
  Local = 'local',
  Development = 'development',
  Production = 'production',
}

export const resolveStage = (): Stage => {
  if (window.location.host.endsWith("nersio.com")) {
    return Stage.Production;
  }

  if (window.location.host.endsWith("nersio.dev")) {
    return Stage.Development;
  }

  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV as Stage;
  }
  return Stage.Local;
};


export const isLocal = () => {
  return resolveStage() === Stage.Local;
};

export const isDevelopment = () => {
  return resolveStage() === Stage.Development;
};

export const isProduction = () => {
  return resolveStage() === Stage.Production;
};
